import { useState } from 'react';
import '../styles.scss';
import { SettingOutlined } from '@ant-design/icons';
import { formatNumber } from '../../../services/mixin';
import MegaTable from '../../../components/MagaTableV2';

export default function VehicleInvoiceDetail({ stData = {} as any }) {
  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.vehicle_owner_total_sale_detail?.list.map((col: any) => {
      if (col.field === 'invoice_sale_total_amount' || col.field === 'unit_price' || col.field === 'service_fee') {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
          valueFormatter: (params: any) => formatNumber(params.value)
        })
      } else if (col.field === 'vehicle_model') {
        temp.push({
          field: "vehicle_model", headerName: col.headerName, cellRenderer: (params: any) => {
            if (params.data.vehicle_model === 'TB') {
              return 'Tải Bus'
            } else if (params.data.vehicle_model === 'DL') {
              return 'Du lịch'
            } else {
              return params.data.vehicle_model
            }
          }
        })
      } else {
        temp.push({
          headerName: col.headerName,
          field: col.field,
          tooltipField: col.field,
        })
      }
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheVehicleInvoiceDetail',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      // {
      //   field: "vehicle_model", headerName: "Dòng xe", cellRenderer: (params: any) => {
      //     if (params.data.vehicle_model === 'TB') {
      //       return 'Tải Bus'
      //     } else if (params.data.vehicle_model === 'DL') {
      //       return 'Du lịch'
      //     } else {
      //       return params.data.vehicle_model
      //     }
      //   }
      // },
      // { field: "engine_no", headerName: "Số máy" },
      // { field: "vehicle_brand", headerName: "Thương hiệu" },
      // { field: "interior_color", headerName: "Màu nội thất" },
      // { field: "engine_type", headerName: "Loại động cơ" },
      // { field: "contract_date", headerName: "Ngày hợp đồng" },
      // { field: "contract_no", headerName: "Số hợp đồng" },
      // { field: "payment_terms_name", headerName: "Hình thức thanh toán" },
      // {
      //   field: "invoice_sale_total_amount", headerName: "Tổng tiền", valueFormatter: (params: any) =>
      //     formatNumber(params.value)
      // },
      // {
      //   field: "unit_price", headerName: "Giá xe", valueFormatter: (params: any) =>
      //     formatNumber(params.value)
      // },
      // {
      //   field: "service_fee", headerName: "Tiền dịch vụ", valueFormatter: (params: any) =>
      //     formatNumber(params.value)
      // }
    ],
    listData: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
  });
  return (
    <>
      <div className="setting-tb-has-tab">
        <div className='settingCol'>
          <div className='ctr-col-setting' onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}>
            <SettingOutlined />
          </div>
        </div>
      </div>
      <div className="custom-page-css w-full flex flex-col items-center justify-between  pt-3">
        <div className={` w-full`}>
          <MegaTable
            stData={{ ...megaTableData, listData: stData.chitiethoadon || [] }}
            stChange={(data) => {
              setMegaTableData((prev: any) => ({ ...prev, ...data }));
            }}
          />
        </div>
      </div>
    </>
  )
}
